<script setup lang="ts">
defineExpose({
  name: "SortDownIcon",
});
</script>

<template>
  <svg
    class="SortDownIcon"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2046_29"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2046_29)">
      <path
        d="M5 10L12 3L19 10H5ZM8.625 8.5H15.375L12 5.125L8.625 8.5ZM5 14H19L12 21L5 14Z"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.SortDownIcon {
  width: 100%;
  height: auto;
  fill: currentcolor;
}
</style>
